export default "__VITE_ASSET__BD11ondo__"